<template>
  <vs-popup
    v-if="passData !== null"
    :title="`Aproval SOS ${passData.name}`"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
    fullscreen
  >
    <EditAprovalSOSPopup
      :activate="activeAproval"
      @callback="callBackPopUp"
      @withClose="loadData"
      :itemPassData="itemPassData"
    />
    <div class="mt-2 w-full vx-row justify-between">
      <section class="vx-col lg:w-1/2 sm:w-full">
        <main>
          <div class="mb-6">
            <img
              :src="
                passData.file !== null
                  ? passData.file.includes('upload//')
                    ? `${url.baseFl}/${passData.file}`
                    : passData.file
                  : passData.file
              "
              alt="sos-img"
              class="rounded-lg shadow-md block w-full mb-4 banner"
            />
            <span v-if="formData.file === null" class="text-xl" style="color: red"
              >Gambar Banner Kosong</span
            >
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>User :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.user !== null ? 'color: black;' : 'color: red;'"
                >{{ passData.user !== null ? passData.user.name : "User Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Nama SOS :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.name !== null ? 'color: black;' : 'color: red;'"
                >{{ passData.name !== null ? passData.name : "Nama SOS Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Nama PIC :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.pic !== null ? 'color: black;' : 'color: red;'"
                >{{ passData.pic !== null ? passData.pic : "Nama PIC Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6" v-if="passData.sub_kategori.kategori !== undefined">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Kategori :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="
                  passData.sub_kategori.kategori !== null
                    ? 'color: black;'
                    : 'color: red;'
                "
                >{{
                  passData.sub_kategori.kategori !== null
                    ? passData.sub_kategori.kategori.name
                    : "Kategori Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Sub-Kategori :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.sub_kategori !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.sub_kategori !== null
                    ? passData.sub_kategori.name
                    : "Sub-Kategori Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Kontak :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.kontak !== null ? 'color: black;' : 'color: red;'"
                >{{ passData.kontak !== null ? passData.kontak : "Kontak Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Deskripsi :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-lg"
                :style="passData.deskripsi !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.deskripsi !== null ? passData.deskripsi : "Deskripsi Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6" v-if="passData.kecamatan.kabkot.provinsi !== undefined">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Provinsi :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="
                  passData.kecamatan.kabkot.provinsi !== null
                    ? 'color: black;'
                    : 'color: red;'
                "
                >{{
                  passData.kecamatan.kabkot.provinsi !== null
                    ? passData.kecamatan.kabkot.provinsi.name
                    : "Provinsi Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6" v-if="passData.kecamatan.kabkot !== undefined">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Kabupaten/Kota :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="
                  passData.kecamatan.kabkot !== null ? 'color: black;' : 'color: red;'
                "
                >{{
                  passData.kecamatan.kabkot !== null
                    ? passData.kecamatan.kabkot.name
                    : "Kabupaten/Kota Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6" v-if="passData.kecamatan !== null">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Kecamatan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.kecamatan !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.kecamatan !== null
                    ? passData.kecamatan.name
                    : "Kecamatan Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Alamat :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-lg"
                :style="passData.alamat !== null ? 'color: black;' : 'color: red;'"
                >{{ passData.alamat !== null ? passData.alamat : "Alamat Kosong" }}</span
              >
            </section>
          </div>
          <div
            class="mb-6"
            v-if="passData.latitude !== null && passData.longitude !== null"
          >
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Peta Lokasi SOS :</strong></h6>
            </section>
            <section class="w-full">
              <GmapMap
                class="mb-4"
                :center="marker"
                :zoom="5"
                map-type-id="terrain"
                style="width: 100%; height: 300px"
              >
                <GmapMarker :position="marker" :clickable="true" @click="marker" />
              </GmapMap>
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Latitude :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.latitude !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.latitude !== null ? passData.latitude : "Latitude Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Longitude :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.longitude !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.longitude !== null ? passData.longitude : "Longitude Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Status Zona :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.status_zona !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.status_zona !== null
                    ? passData.status_zona.name
                    : "Status Zonal Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6" v-if="passData.status_zona !== null">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Zonasi :</strong></h6>
            </section>
            <section class="w-full">
              <vs-table
                stripe
                :data="passData.zonasi ? passData.zonasi : []"
                :max-items="10"
                pagination
              >
                <template slot="thead">
                  <vs-th v-if="passData.status_zona.id === 2">Kecamatan</vs-th>
                  <vs-th>Kab/Kot</vs-th>
                  <vs-th>Provinsi</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td v-if="passData.status_zona.id === 2" :data="data[indextr]">
                      {{ data[indextr].name }}
                    </vs-td>
                    <vs-td
                      :data="
                        passData.status_zona.id === 2
                          ? data[indextr].kabkot
                          : data[indextr]
                      "
                    >
                      {{
                        passData.status_zona.id === 2
                          ? data[indextr].kabkot.name
                          : data[indextr].name
                      }}
                    </vs-td>
                    <vs-td
                      :data="
                        passData.status_zona.id === 2
                          ? data[indextr].kabkot.provinsi
                          : data[indextr].provinsi
                      "
                    >
                      {{
                        passData.status_zona.id === 2
                          ? data[indextr].kabkot.provinsi.name
                          : data[indextr].provinsi.name
                      }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Status Bayar :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="passData.status_bayar !== null ? 'color: black;' : 'color: red;'"
                >{{
                  passData.status_bayar !== null
                    ? passData.status_bayar === 1
                      ? "Berbayar"
                      : "Gratis"
                    : "Status Bayar Kosong"
                }}</span
              >
            </section>
          </div>
        </main>
      </section>

      <section class="vx-col lg:w-1/2 sm:w-full">
        <main>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>File Persyaratan</strong></h6>
            </section>
            <section class="w-full">
              <vs-table stripe :data="persyaratanList" :max-items="10" pagination>
                <template slot="thead">
                  <vs-th>Syarat</vs-th>
                  <vs-th>File</vs-th>
                  <vs-th>Status</vs-th>
                  <vs-th>Aksi</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                    <vs-td>
                      {{
                        getFileSyarat(data[indextr].id) !== undefined
                          ? getFileSyarat(data[indextr].id).file
                            ? getFileSyarat(data[indextr].id).file.split("/")[3]
                            : "(File Kosong)"
                          : "(File Kosong)"
                      }}
                      <span v-if="getFileSyarat(data[indextr].id) !== undefined">
                        <a
                          v-if="getFileSyarat(data[indextr].id).file !== null"
                          :href="`${url.baseFl}/${getFileSyarat(data[indextr].id).file}`"
                          target="_blank"
                          >Download File</a
                        >
                      </span>
                    </vs-td>
                    <vs-td>
                      <div v-if="getFileSyarat(data[indextr].id) !== undefined">
                        <span>
                          {{
                            getFileSyarat(data[indextr].id).status === 1
                              ? "Disetujui"
                              : "Tidak Disetujui"
                          }}
                        </span>
                      </div>
                      <div v-else>
                        <span>(File Kosong)</span>
                      </div>
                    </vs-td>
                    <vs-td>
                      <vs-button
                        v-if="getFileSyarat(data[indextr].id) !== undefined"
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-edit"
                        @click="
                          openPopUp(getFileSyarat(data[indextr].id), data[indextr].name)
                        "
                      >
                      </vs-button>
                      <span v-else> (File Kosong) </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Status Aproval :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                v-if="syaratKumpuls.length !== 0"
                class="text-xl"
                :style="
                  syaratKumpuls.filter((v) => v.status === 1).length ===
                  persyaratanList.length
                    ? 'color: green;'
                    : 'color: red;'
                "
                >{{
                  syaratKumpuls.filter((v) => v.status === 1).length ===
                  persyaratanList.length
                    ? "Disetujui"
                    : "Belum Disetujui"
                }}</span
              >
              <span v-else class="text-xl" style="color: red"> Belum Disetujui </span>
            </section>
          </div>
        </main>
      </section>
      <!-- <div class="vx-col w-full mb-8">
        <p class="mb-4 flex justify-end"><strong>Aproval Sahabat ZX</strong></p>
        <div class="flex justify-end gap-2">
          <p>{{ statusUser ? "Disetujui" : "Tidak Disetujui" }}</p>
          <vs-switch
            :color="statusUser ? 'success' : 'danger'"
            v-model="statusUser"
          />
        </div>
      </div> -->
    </div>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <!-- <vs-button color="danger" class="mr-2 rounded-2xl" @click="updateAllSyarat(2)"
          >Tidak Disetujui</vs-button
        > -->
        <vs-button color="success" class="ml-2 rounded-2xl" @click="updateAllSyarat()"
          >Update</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import EditAprovalSOSPopup from "@/views/sos/component/EditAprovalSOSPopup.vue";
import emptyImage from "@/assets/images/elements/empty.png";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import url from "@/url.js";

export default {
  components: {
    EditAprovalSOSPopup,
    VuePhoneNumberInput,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      marker: { lat: -7.073736003627849, lng: 107.65912173890158 },
      zoom: 5,
      zonasiList: [],
      statusAproval: [
        {
          id: 1,
          text: "Disetujui",
        },
        {
          id: 2,
          text: "Tidak Disetujui",
        },
      ],
      activeAproval: false,
      itemPassData: null,
      persyaratanList: [],
      syaratKumpuls: [],
      formData: {
        file: emptyImage,
        name: "",
        kat_id: null,
        alamat: "",
        kontak: "",
        latitude: null,
        longitude: null,
        pic: "",
        kabkot_id: null,
        sub_id: null,
        kecamatan_id: null,
        provinsi_id: null,
        status_zona: null,
        zonasi: "",
        status_bayar: null,
        deskripsi: "",
      },
    };
  },
  computed: {
    provinsiList() {
      return this.$store.state.wilayah.provinsiList;
    },
    provinsiSelect() {
      return this.formData.provinsi_id;
    },
    userCompute() {
      return this.formData.user_id;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.file = this.getPathFoto(this.passData);
        this.formData.latitude = this.passData.latitude;
        this.formData.longitude = this.passData.longitude;
        this.formData.provinsi_id =
          this.passData.kecamatan.kabkot.provinsi !== undefined
            ? this.passData.kecamatan.kabkot.provinsi.id
            : null;
        this.formData.name = this.passData.name;
        this.formData.kat_id =
          this.passData.sub_kategori.kategori !== undefined
            ? this.passData.sub_kategori.kategori.id
            : null;
        this.formData.alamat = this.passData.alamat;
        this.formData.kontak = this.passData.kontak;
        this.formData.pic = this.passData.pic;
        this.formData.kabkot_id =
          this.passData.kecamatan.kabkot !== undefined
            ? this.passData.kecamatan.kabkot.id
            : null;
        this.formData.status_zona = this.passData.status_zona
          ? this.passData.status_zona.id
          : null;
        this.formData.sub_id = this.passData.sub_kategori
          ? this.passData.sub_kategori.id
          : null;
        this.formData.kecamatan_id = this.passData.kecamatan
          ? this.passData.kecamatan.id
          : null;
        this.formData.status_bayar = this.passData.status_bayar;
        this.formData.deskripsi = this.passData.deskripsi;
        this.marker = {
          lat: parseFloat(this.passData.latitude),
          lng: parseFloat(this.passData.longitude),
        };
        this.zonasiList = this.passData.zonasi;
        this.persyaratanList = this.$store.getters["sos/getFilteredSyarat"](
          this.passData.sub_kategori.id
        );
        console.log(
          (this.persyaratanList = this.$store.getters["sos/getFilteredSyarat"](
            this.passData.sub_kategori.id
          ))
        );
        this.getSyaratKumpul();
      } else {
        this.resetForm();
      }
    },
    provinsiSelect() {
      if (this.formData.provinsi_id !== null) {
        this.kabkotList = this.$store.getters["wilayah/getFilteredKabKot"](
          this.formData.provinsi_id
        );
      }
    },
    userCompute() {
      if (this.formData.user_id !== null) {
        let user = this.userList.find((v) => v.id === this.formData.user_id);
        this.formData.no_telp = user.no_telp;
        this.formData.email = user.email;
      }
    },
  },
  methods: {
    callBackPopUp(val) {
      this.activeAproval = val;
      this.itemPassData = null;
    },
    loadData(val) {
      if (val) {
        this.getFileSyarat(val.file.id).status = val.file.status;
        this.getFileSyarat(val.file.id).deskripsi = val.file.deskripsi;
      }
    },
    openPopUp(item, nameSyarat) {
      this.activeAproval = true;
      this.itemPassData = { ...item, nameSyarat: nameSyarat };
    },
    getFileSyarat(id) {
      return this.syaratKumpuls.find((v) => v.syarat.id === id);
    },
    resetForm() {
      this.zoom = 5;
      this.formData.file = this.emptyImage;
      this.formData.name = "";
      this.formData.kat_id = null;
      this.formData.alamat = "";
      this.formData.kontak = "";
      this.formData.latitude = null;
      this.formData.longitude = null;
      this.formData.pic = "";
      this.formData.kabkot_id = null;
      this.formData.sub_id = null;
      this.formData.kecamatan_id = null;
      this.formData.status_zona = null;
      this.formData.zonasi = null;
      this.zonasiList = [];
      this.formData.provinsi_id = null;
      this.formData.status_bayar = null;
      this.formData.deskripsi = "";
      this.persyaratanList = [];
      this.syaratKumpuls = [];
      this.marker = { lat: -7.073736003627849, lng: 107.65912173890158 };
    },
    profile() {
      return JSON.parse(localStorage.getItem("profileAccess")).data;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    updateAllSyarat() {
      this.$vs.loading({
        color: "primary",
      });
      return new Promise((resolve) => {
        this.syaratKumpuls.forEach((v) => this.updateSyarat(v));
        resolve(this.closeWithLoad(true));
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    updateSyarat(data) {
      this.$store
        .dispatch("sos/cudSyaratKumpulSOS", [
          {
            id: data.id,
            syarat_id: data.syarat.id,
            status: data.status,
            sos_id: this.passData.id,
            deskripsi: "-",
            file: data.file,
          },
        ])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.itemEdit !== null
                ? "Edit File Persyaratan Sukses!"
                : "Tambah File Persyaratan Sukses!",
            text:
              this.itemEdit !== null
                ? `File Persyaratan ${v.file.split("/").splice(-1)[0]} Berhasil diedit`
                : `File Persyaratan ${v.file.split("/").splice(-1)[0]} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData(idStatus) {
      let id = {};

      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.formData.zonasi =
        this.zonasiList.length !== 0 ? this.zonasiList.reduce((v) => v.id).join(",") : "";
      this.$store
        .dispatch("sos/cudSOS", [
          Object.assign(this.formData, id, {
            user_id: this.profile.id,
            status: idStatus,
          }),
        ])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Aproval SOS Sukses!"
                : "Tambah Aproval SOS Sukses!",
            text:
              this.passData !== null
                ? `Aproval SOS ${v.name} Berhasil diedit`
                : `Aproval SOS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
          this.resetForm();
        });
    },
    getSyaratKumpul() {
      this.$vs.loading({
        color: "primary",
      });
      this.$store
        .dispatch("sos/getSyaratKumpulSOS", { sos_id: this.passData.id })
        .then((v) => {
          this.$vs.loading.close();
          this.syaratKumpuls = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    updateCurrFileSK(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_sk = e.target.result;
          this.binaryFileSK = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrFilePenunjukan(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_penunjukan = e.target.result;
          this.binaryFilePenunjukan = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrFileFoto(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_kantor = e.target.result;
          this.binaryFoto = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  max-height: 300px;
  max-width: 100%;
  overflow: auto;
  object-fit: cover;
}
</style>
